//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'elMenu',
  props: {},
  data: function data() {
    return {};
  },
  mounted: function mounted() {},
  watch: {},
  methods: {}
};